import { Link, useLocation } from 'react-router-dom';

// A versão anterior era a tela do gerador de baixo código que originou o
// portal: em inglês e falando com quem estava construindo a aplicação
// ("Tell me more about this page, so I can generate it"), não com quem usa.
// Quem chega aqui errou um endereço ou seguiu um link velho, e precisa de uma
// saída, não de um convite para gerar a página.

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <span
        aria-hidden="true"
        className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0"
      >
        404
      </span>

      <div className="relative z-10 max-w-md">
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-900">
          Página não encontrada
        </h1>

        <p className="mt-2 text-sm text-foreground-500 font-mono break-all">{location.pathname}</p>

        <p className="mt-4 text-base text-foreground-600 leading-relaxed">
          O endereço não existe ou a página foi movida. Se você chegou por um link salvo, ele pode
          estar desatualizado.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/dashboard"
            className="px-5 py-2.5 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors whitespace-nowrap"
          >
            Ir para o painel
          </Link>
          <Link
            to="/"
            className="px-5 py-2.5 rounded-md border border-background-300/60 text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            Voltar ao início
          </Link>
        </div>
      </div>
    </div>
  );
}
